'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { useMobileSearch } from '@eliadmin/core/src/components/header/mobile-search';
import { useRef } from 'react';
import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { FiSearch } from 'react-icons/fi';

// Brand-specific trigger only. Dialog, queries, pricing and result rendering live in core.
export type SearchButtonProps = Omit<ButtonProps, 'onClick' | 'className'> & {
  className?: {
    root?: string;
    icon?: string;
  };
};

export function SearchButton(props: SearchButtonProps) {
  const { className, ...buttonProps } = props;
  const sharedOpen = useMobileSearch(s => s.isOpen);
  const toggle = useMobileSearch(s => s.toggle);
  const sharedOpenRef = useRef(sharedOpen);
  sharedOpenRef.current = sharedOpen;
  const notifyOpen = (next: boolean) => {
    if (sharedOpenRef.current === next) return;
    sharedOpenRef.current = next;
    toggle();
  };
  return (
    <SearchDrawer
      onOpenChange={notifyOpen}
      trigger={
        <button
          type="button"
          className={cn(
            'flex flex-col items-center space-y-1',
            'ea-bottom-bar__item text-muted-foreground',
            className?.root,
          )}
        >
          <FiSearch className={cn('h-6 w-6', 'ea-search-button__icon', className?.icon)} />
          <span className={cn('text-center text-xs', 'ea-bottom-bar__item__label')}>Vyhľadať</span>
        </button>
      }
    />
  );
}
